import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved ? saved === 'dark' : false;
  });

  // Animation state: null | 'start' | 'fill' | 'drain'
  const [themeAnim, setThemeAnim] = useState(null);

  useEffect(() => {
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
    if (isDark) {
      document.documentElement.classList.add('dark-theme');
    } else {
      document.documentElement.classList.remove('dark-theme');
    }
  }, [isDark]);

  const toggleTheme = useCallback(() => {
    // 1. kick off the overlay
    setThemeAnim('start');

    // 2. after fill is half-done, flip the actual theme (screen is hidden by overlay)
    setTimeout(() => {
      setIsDark(prev => !prev);
    }, 320);

    // 3. start draining after theme has flipped
    setTimeout(() => {
      setThemeAnim('drain');
    }, 420);

    // 4. cleanup
    setTimeout(() => {
      setThemeAnim(null);
    }, 820);
  }, []);

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme, themeAnim }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) throw new Error('useTheme must be used within ThemeProvider');
  return context;
};
